<div class="sound-icon">
  @for (scale of scales(); track $index) {
    <div
      class="sound-icon__bar"
      [style.transform]="'scaleY(' + scale + ')'"
      [style.background]="color()"
    ></div>
  }
</div>
